document.addEventListener('DOMContentLoaded', function() {
  // Set initial active_index class on gallery for all product items
  document.querySelectorAll('.product-item').forEach(item => {
    const gallery = item.querySelector('.product-item__gallery');
    if (gallery) {
      gallery.classList.add('active_index');
    }

    // Make sure the main image doesn't have the active_index class
    const mainImage = item.querySelector('.product-item__bg');
    if (mainImage) {
      mainImage.classList.remove('active_index');
    }
  });

  // Initialize image sliders
  initProductImageSliders();

  // Initialize color swatches
  initColorSwatches();

  // Initialize swipe functionality
  initGallerySwipe();
});

// Hydrate a deferred gallery image placeholder with a real <img>
function hydrateDeferredImage(el) {
  if (!el.classList.contains('gallery-image--deferred')) return;

  const src = el.getAttribute('data-deferred-src');
  const srcset = el.getAttribute('data-deferred-srcset');
  const sizes = el.getAttribute('data-deferred-sizes');
  const alt = el.getAttribute('data-deferred-alt') || '';

  if (!src) return;

  const wrapper = document.createElement('div');
  wrapper.className = 'image-wrapper lazy-image';

  const img = document.createElement('img');
  img.src = src;
  if (srcset) img.srcset = srcset;
  if (sizes) img.sizes = sizes;
  img.alt = alt;
  img.loading = 'lazy';
  img.decoding = 'async';
  img.className = 'image__img';

  wrapper.appendChild(img);
  el.appendChild(wrapper);
  el.classList.remove('gallery-image--deferred');
}

function initProductImageSliders() {
  // Delegated on document so it survives the grid being re-rendered
  // (filters, sorting, infinite scroll)
  document.addEventListener('click', function(e) {
    const control = e.target.closest('[data-gallery-prev], [data-gallery-next], [data-gallery-dot]');
    if (!control) return;

    e.preventDefault();
    e.stopPropagation();

    let target;
    if (control.hasAttribute('data-gallery-prev')) {
      target = 'prev';
    } else if (control.hasAttribute('data-gallery-next')) {
      target = 'next';
    } else {
      target = parseInt(control.getAttribute('data-gallery-dot'), 10);
    }

    goToGalleryImage(control.closest('.product-item'), target);
  }, true); // capture phase, so it runs before the product link or other theme click handlers
}

// Gallery images currently in use (swatch switches hide surplus slots with display:none)
function getVisibleGalleryImages(gallery) {
  return Array.from(gallery.querySelectorAll('.product-item__gallery-image'))
    .filter(img => img.style.display !== 'none');
}

// Keep the dashes in step with the gallery: one dash per visible image, active one highlighted
function syncGalleryDots(productItem) {
  const dotsWrap = productItem && productItem.querySelector('[data-gallery-dots]');
  const gallery = productItem && productItem.querySelector('.product-item__gallery');
  if (!dotsWrap || !gallery) return;

  const images = getVisibleGalleryImages(gallery);
  const activeIndex = Math.max(0, images.findIndex(img => img.classList.contains('active')));

  if (dotsWrap.children.length !== images.length) {
    dotsWrap.innerHTML = '';
    images.forEach((img, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'gallery-dot';
      dot.setAttribute('data-gallery-dot', i);
      dot.setAttribute('aria-label', `Show image ${i + 1}`);
      dotsWrap.appendChild(dot);
    });
  }
  dotsWrap.hidden = images.length <= 1;

  Array.from(dotsWrap.children).forEach((dot, i) => {
    dot.classList.toggle('is-active', i === activeIndex);
  });
}

// target: 'prev' | 'next' | image index
function goToGalleryImage(productItem, target) {
  if (!productItem) return;
  const gallery = productItem.querySelector('.product-item__gallery');
  const mainProductImage = productItem.querySelector('.product-item__bg');
  const lifestyleImage = productItem.querySelector('.product-item__bg__under.product-lifestyle-image');
  const videoContainer = productItem.querySelector('.product-video-container');

  // Disable lifestyle images and videos for this product item
  productItem.setAttribute('data-lifestyle-disabled', 'true');

  // Clear any existing timer
  if (productItem.lifestyleTimer) {
    clearTimeout(productItem.lifestyleTimer);
  }

  // Re-enable after 10 seconds
  productItem.lifestyleTimer = setTimeout(() => {
    productItem.removeAttribute('data-lifestyle-disabled');
    delete productItem.lifestyleTimer;
  }, 10000);

  // Remove active class from lifestyle image
  if (lifestyleImage && lifestyleImage.classList.contains('active')) {
    lifestyleImage.classList.remove('active');
  }

  // Remove active class from video container
  if (videoContainer && videoContainer.classList.contains('active')) {
    videoContainer.classList.remove('active');
  }

  // Toggle active_index class
  if (mainProductImage.classList.contains('active_index')) {
    mainProductImage.classList.remove('active_index');
    gallery.classList.add('active_index');
  }

  const images = getVisibleGalleryImages(gallery);
  if (!images.length) return;
  const currentActive = gallery.querySelector('.product-item__gallery-image.active');
  let currentIndex = Math.max(0, images.indexOf(currentActive));
  let newIndex;

  // Determine target
  if (target === 'prev') {
    newIndex = (currentIndex - 1 + images.length) % images.length;
  } else if (target === 'next') {
    newIndex = (currentIndex + 1) % images.length;
  } else {
    newIndex = Math.min(Math.max(0, target), images.length - 1);
  }

  // Hydrate and update
  hydrateDeferredImage(images[newIndex]);
  if (currentActive) currentActive.classList.remove('active');
  images[newIndex].classList.add('active');

  syncGalleryDots(productItem);
}

// Color swatches now handled by collection-color-swatches.js (fetch on click)

function initColorSwatches() {
  // Handle sibling swatches only (color swatches use fetch-on-click in collection-color-swatches.js)
  const siblingSwatches = document.querySelectorAll('[data-sibling-link]');
  siblingSwatches.forEach(swatch => {
    swatch.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const productGridItem = this.closest('[data-product-grid-item]');
      if (!productGridItem) return;

      // Update active state
      const allSiblingSwatches = productGridItem.querySelectorAll('.siblings__link');
      allSiblingSwatches.forEach(s => s.classList.remove('siblings__link--current'));
      this.closest('.siblings__link').classList.add('siblings__link--current');

      // Get data
      const siblingUrl = this.getAttribute('data-sibling-link');
      const siblingPrice = this.getAttribute('data-sibling-price');
      const siblingCutline = this.getAttribute('data-sibling-cutline');
      const siblingImage = this.getAttribute('data-sibling-image');

      // Toggle active_index class
      const mainImageContainer = productGridItem.querySelector('[data-product-image-default]');
      const galleryContainer = productGridItem.querySelector('.product-item__gallery');

      if (mainImageContainer) {
        mainImageContainer.classList.add('active_index');
        if (galleryContainer) {
          galleryContainer.classList.remove('active_index');
        }
      }

      // Update product link
      const productLinks = productGridItem.querySelectorAll('[data-product-link]');
      productLinks.forEach(link => {
        link.setAttribute('href', siblingUrl);
      });

      // Update price
      const priceElement = productGridItem.querySelector('[data-product-price] .price');
      if (priceElement && siblingPrice) {
        priceElement.innerHTML = `<span class="new-price">${siblingPrice}</span>`;
      }

      // Update cutline
      const cutlineElement = productGridItem.querySelector('[data-product-cutline]');
      if (cutlineElement && siblingCutline) {
        cutlineElement.textContent = siblingCutline;
      }

      // Update sibling image
      const siblingImageElement = productGridItem.querySelector('[data-product-image-sibling]');
      if (siblingImageElement && siblingImage) {
        siblingImageElement.style.backgroundImage = `url(${siblingImage})`;
        siblingImageElement.style.display = 'block';
      }
    });
  });
}

// Gallery Swipe Functionality
// Delegated on document so it also covers product cards swapped in later
// (filters, sorting, infinite scroll) - per-card listeners bound on page load
// never reached those.
function initGallerySwipe() {
  const SWIPE_THRESHOLD = 30;

  let startX = 0;
  let startY = 0;
  let activeItem = null;  // card the current touch/drag started on
  let swipedItem = null;  // card we just swiped, to swallow its tap-through click

  function getX(e) {
    return e.type.includes('mouse') ? e.pageX :
      (e.touches?.[0]?.clientX || e.changedTouches?.[0]?.clientX || 0);
  }

  function getY(e) {
    return e.type.includes('mouse') ? e.pageY :
      (e.touches?.[0]?.clientY || e.changedTouches?.[0]?.clientY || 0);
  }

  // Product card under the pointer, if it has a swipeable gallery
  function getSwipeableItem(target) {
    const swipeTarget = target && target.closest && target.closest('.product-item__image');
    if (!swipeTarget) return null;

    const item = swipeTarget.closest('.product-item');
    if (!item || !item.querySelector('[data-gallery-dots]')) return null;

    const gallery = item.querySelector('.product-item__gallery');
    if (!gallery || getVisibleGalleryImages(gallery).length <= 1) return null;

    return item;
  }

  function handleStart(e) {
    activeItem = getSwipeableItem(e.target);
    swipedItem = null;
    if (!activeItem) return;
    startX = getX(e);
    startY = getY(e);
  }

  function handleEnd(e) {
    if (!activeItem) return;
    const item = activeItem;
    activeItem = null;

    const diffX = getX(e) - startX;
    const diffY = getY(e) - startY;

    // Ignore mostly-vertical drags so page scroll isn't hijacked
    if (Math.abs(diffX) > SWIPE_THRESHOLD && Math.abs(diffX) > Math.abs(diffY)) {
      swipedItem = item;
      // Stop the tap-through link navigation this swipe would otherwise trigger
      e.preventDefault();
      goToGalleryImage(item, diffX < 0 ? 'next' : 'prev');
    }
  }

  document.addEventListener('touchstart', handleStart, { passive: true });
  document.addEventListener('touchend', handleEnd, { passive: false });
  document.addEventListener('touchcancel', () => { activeItem = null; });

  document.addEventListener('mousedown', handleStart);
  document.addEventListener('mouseup', handleEnd);

  // Belt-and-braces: some mobile browsers still fire a synthetic click
  // after touchend even when preventDefault was called on it, since the
  // click target (the <a>) is a different element than the touchend
  // target. Swallow that one click if we just navigated via swipe.
  document.addEventListener('click', (e) => {
    if (!swipedItem) return;
    const item = swipedItem;
    swipedItem = null;
    if (e.target.closest('.product-item') === item && e.target.closest('.product-link')) {
      e.preventDefault();
    }
  }, true);
}
